import { render, staticRenderFns } from "./UploadDocumentResources.vue?vue&type=template&id=6e77a3f2&scoped=true"
import script from "./UploadDocumentResources.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentResources.vue?vue&type=script&lang=ts"
import style0 from "./UploadDocumentResources.vue?vue&type=style&index=0&id=6e77a3f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e77a3f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e77a3f2')) {
      api.createRecord('6e77a3f2', component.options)
    } else {
      api.reload('6e77a3f2', component.options)
    }
    module.hot.accept("./UploadDocumentResources.vue?vue&type=template&id=6e77a3f2&scoped=true", function () {
      api.rerender('6e77a3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/UploadDocumentResources.vue"
export default component.exports